import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({ brand_name: "Sabor Dubom", anchored_channels: [] });
  const [unit, setUnit] = useState(() => {
    const v = localStorage.getItem("mi_unit");
    return v ? parseInt(v, 10) : 100;
  });
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch {
      /* not authenticated yet */
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const setUnitPersist = (u) => {
    setUnit(u);
    localStorage.setItem("mi_unit", String(u));
  };

  const updateSettings = async (payload) => {
    const { data } = await api.put("/settings", payload);
    setSettings(data);
    return data;
  };

  return (
    <SettingsContext.Provider value={{ settings, unit, setUnit: setUnitPersist, refresh, updateSettings, loaded }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
